import CllReportingTable from './CllReportingTable';

export default CllReportingTable;
